import clsx from 'clsx'
import React, { FC, useState } from 'react'

import { BarProps } from '@Components/CMS/Bars/types'
import { MarketingEvents } from '@Components/CMS/Bars/Urgency/Helpers'
import { SlimProgressTimer } from '@Components/CMS/Bars/Urgency/Slim/SlimProgressTimer'
import { RTEContent } from '@Components/RTEContent'
import { getRTEFieldValue, useDynamicVariables } from '@Globals/CMS/FieldHelpers'
import { formatTimer } from '@Globals/TimeHelpers'

import styles from './SlimUrgencyBar.module.scss'

export const SlimUrgencyBar: FC<BarProps> = ({ bar, order }) => {
  const [timer, setTimer] = useState('00:00:00')
  const { fields, urgencyTimerDateEnd, urgencyTimerDateStart } = bar
  const dynamicVariables = useDynamicVariables()
  const mobileRTEField = getRTEFieldValue(fields, 'textMobile')
  const leftRTEField = getRTEFieldValue(fields, 'textLeft')
  const rightRTEField = getRTEFieldValue(fields, 'textRight')

  return (
    <div className={styles.container} style={{ background: bar.backgroundColor, color: bar.textColor, order }}>
      <RTEContent className={clsx(styles.content, styles.mobile)} data={mobileRTEField} dynamicVariables={dynamicVariables} />
      <div className={`${styles.content} ${styles.desktop}`}>
        {leftRTEField && <RTEContent className={styles.text} data={leftRTEField} dynamicVariables={dynamicVariables} elementType="span" />}
        {rightRTEField && <RTEContent className={styles.text} data={rightRTEField} dynamicVariables={dynamicVariables} elementType="span" />}
      </div>
      <div className={styles.timer}>{timer}</div>
      <SlimProgressTimer
        className={styles.progress}
        config={{
          type: MarketingEvents.FREE_SHIPPING,
          range: { to: new Date(urgencyTimerDateEnd!), from: new Date(urgencyTimerDateStart!) },
        }}
        fixed={1}
        hourlyReset={bar.addons?.includes('reset-urgency-timer-hourly')}
        progressColor={bar.textColor}
        startAtFifty={bar.addons?.includes('start-urgency-timer-at-50')}
        timeUpdated={({ hours, minutes, seconds }) => setTimer(`${formatTimer(hours)}:${formatTimer(minutes)}:${formatTimer(seconds)}`)}
      />
    </div>
  )
}

export default SlimUrgencyBar
